export default __webpack_public_path__ + "static/media/fa-brands-400.b9d45ca2.ttf";